import { createFileRoute } from '@tanstack/react-router';
import {
  createGroupBroadcastNewRoute,
  validateGroupBroadcastNewSearch,
} from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/groups/$id/admin/broadcasts/new/',
)({
  validateSearch: validateGroupBroadcastNewSearch,
  ...createGroupBroadcastNewRoute({
    kind: 'space',
    fromId: '/_authed/groups/$id/admin/broadcasts/new/',
  }),
});
